import type { IconProps } from "./icon-types";

/**
 * 클라우드 업로드(cloud upload, outline). 서버/클라우드로의 업로드 진입점·진행 상태에서 사용.
 *
 * Ionicons의 `IoCloudUploadOutline` path를 인라인으로 그대로 재현 —
 * c6 패키지는 외부 아이콘 라이브러리를 import하지 않으므로(RFC-design-system-split §아이콘).
 * Ionicons 원본을 그대로 사용하므로 512 그리드 / stroke 기반(색은 currentColor 상속).
 */
export const CloudUploadIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 512 512"
    fill="none"
    stroke="currentColor"
    strokeWidth="32"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M320 367.79h76c55 0 100-29.21 100-83.6s-53-81.47-96-83.6c-8.89-85.06-71-136.8-144-136.8-69 0-113.44 45.79-128 91.2-60 5.7-112 43.88-112 106.4s54 106.4 120 106.4h56" />
    <path d="m320 255.79-64-64-64 64m64 192.42V207.79" />
  </svg>
);
